export default __webpack_public_path__ + "static/media/GBGC_Login_logo.4e5148cc.png";